export const camelCaseToWords = (str: string): string => {
    if (str) {
        const words = str.replace(/([a-z])([A-Z])/g, '$1 $2');
        const splitWords = words.split(' ');
        return splitWords[1];
    }
    return '';
};
